import React from 'react';

import { Tooltip } from 'antd';

import IxOneLogo from 'assets/IX_One_Logo2285.png';

const IxOneCertifiedIcon = () => {
  return (
    <Tooltip title='IX-ONE Certified' placement='top'>
      <span style={{ display: 'inline-flex', zIndex: 30 }}>
        <img
          src={IxOneLogo}
          alt='IX-ONE Certified'
          style={{ width: 19, height: 19, objectFit: 'contain' }}
        />
      </span>
    </Tooltip>
  );
};

export default IxOneCertifiedIcon;
